module.exports = __webpack_public_path__ + "img/img_boss.688ad059.png";